import React, { useContext, useEffect, useState } from 'react'
import 'src/views/container/cms/content.scss'
import '../../../scss/style.scss'
import { convertDuration, getThumbnail, isEmpty } from '../../../views/utils/helper'
import moment from 'moment'
import { GlobalContext } from 'src/views/context/GlobalState'
import CustomPreviewListCard from 'src/views/container/AssetManager/customPreviewListCard'
import useAxios from 'axios-hooks'
import { CONTENT_FILTER_XAVIER } from 'src/views/utils/urls'
import { AppContext } from 'src/views/context/app'
import InfiniteScroll from 'react-infinite-scroll-component'
import { PAGE_SIZE } from 'src/views/utils/constants'
import { isArray } from 'lodash'

const DefaultDynamicPreview = ({
  title = 'Swimlane',
  filterData,
  orderBy = 'modified_date',
  reverse = false,
}) => {
  console.log('filterData', filterData)
  const { userSessionObj } = useContext(GlobalContext)
  const { setLoader } = useContext(AppContext)
  const [page, setPage] = useState(1)
  const [contentData, setContentData] = useState([])
  const language = localStorage.getItem('language') || 'en'

  const [{ data: contentList, loading: contentListLoading }, contentListCall] = useAxios(
    {
      url: CONTENT_FILTER_XAVIER,
      method: 'post',
    },
    { manual: true },
  )

  useEffect(() => {
    setPage(1)
    contentListCall({
      data: {
        filters: filterData,
        page: 1,
        order_by: orderBy === 'title' ? `title.${language}` : orderBy,
        reverse: reverse,
        page_size: PAGE_SIZE,
      },
    })
  }, [orderBy, reverse])

  useEffect(() => {
    setLoader(contentListLoading)
  }, [contentListLoading])

  useEffect(() => {
    if (contentList && contentList.success) {
      page === 1
        ? setContentData(contentList.data)
        : setContentData((contentData) => [...contentData, ...contentList.data])
    }
  }, [contentList])

  const handleNextPage = () => {
    contentListCall({
      data: {
        filters: filterData,
        page: page + 1,
        order_by: orderBy === 'title' ? `title.${language}` : orderBy,
        reverse: reverse,
        page_size: PAGE_SIZE,
      },
    })
    setPage((page) => page + 1)
  }

  return (
    <div style={{ marginTop: '5px' }}>
      <div className="d-flex justify-content-between align-items-start">
        <div>
          <h5
            style={{
              color: '#191818',
              fontSize: '30px',
              fontWeight: '700',
              marginBlockEnd: '0',
            }}
          >
            {title.toUpperCase()} PREVIEW
          </h5>
        </div>
      </div>
      {/* // filter and list/grid toggle div */}
      <div
        className="d-flex justify-content-center"
        style={{
          paddingTop: 'max(.6vw,8px)',
          margin: '0 auto 2vh',
          width: '100%',
          // outline: '2px solid red',
          position: 'relative',
        }}
      >
        <h6 style={{ marginRight: 'auto', fontSize: '14px', color: '#000' }}>
          {contentList?.total || 0} Items Added to the {title}
        </h6>
        <h6 style={{ marginLeft: 'auto', fontSize: '14px' }}>*Auto Generated Content Data</h6>
      </div>
      {/* // asset manager lookalike content manager(content listing) */}
      <div className="position-relative overflow-hidden">
        <div
          className="custom-scrollbar-vertical"
          style={{
            height: '53vh',
            overflowY: 'auto',
            padding: '30px 2px 10px 2px',
            overflowX: 'hidden',
          }}
        >
          <div
            className="d-flex justify-content-center align-items-center w-100 bg-black text-white position-absolute rounded-2"
            style={{
              fontSize: 'max(0.63vw,10px)',
              gap: '0 .6%',
              padding: '2px .5vw',
              zIndex: '10',
              position: 'fixed',
              top: '0',
            }}
          >
            <div style={{ width: '2%', height: '100%' }}></div>
            <div style={{ width: '9%', height: '100%' }}></div>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{ width: '85%', background: 'none' }}
            >
              <p style={{ marginBlockEnd: '0', width: '20%', background: 'none' }}>Title</p>
              <p style={{ marginBlockEnd: '0', width: '10%', background: 'none' }}>Duration</p>
              <p style={{ marginBlockEnd: '0', width: '10%', background: 'none' }}>Publish Date</p>
              <p style={{ marginBlockEnd: '0', width: '10%', background: 'none' }}>Content Type</p>
              <p
                style={{
                  marginBlockEnd: '0',
                  width: '20%',
                  background: 'none',
                }}
              >
                Category
              </p>
              <div style={{ width: '2%' }}></div>
            </div>
          </div>
          <InfiniteScroll
            dataLength={contentData.length} //This is important field to render the next data
            next={handleNextPage}
            hasMore={contentList && contentList.total > page * 20}
            style={{ overflowX: 'hidden' }}
            loader={<p>Loading...</p>}
            className="scrollbar-class"
            height={`48vh`}
            scrollableTarget="scrollableDiv"
          >
            <ul className="list-unstyled pr-2">
              {!isEmpty(contentData) ? (
                contentData.map((info, index) => (
                  <li key={index}>
                    <CustomPreviewListCard
                      disableHoverEffect={true}
                      cardStyle={{ marginBottom: '.84vw', aspectRatio: '1181/71' }}
                      cardImage={getThumbnail(
                        userSessionObj.session_data.cf_domain_name,
                        info?.thumbnail,
                      )}
                      playIconForVideo={true}
                      fileName={info?.title}
                      rightText={moment(info?.publish_time).format('DD MMM YYYY')}
                      duration={'N/A'}
                      contentType={info?.video_type}
                      categories={
                        isArray(info?.category)
                          ? info?.category.map((info) => info.name)
                          : [info?.category.name]
                      } // categories
                      actionButtonAction={null}
                    />
                  </li>
                ))
              ) : (
                <h5 className="no-data-text">No Content Found!</h5>
              )}
            </ul>
          </InfiniteScroll>
        </div>
        <p style={{ marginBlockEnd: '0', fontSize: 'max(0.73vw,10px)', color: '#000' }}>
          * The items displayed are NOT Static i.e. these will change dynamically based on the
          Defined Filtering Criteria.
        </p>
      </div>
    </div>
  )
}

export default DefaultDynamicPreview
